import dayjs from "dayjs";

export const VAT_RETURN_PERIOD_STORAGE_KEY =
  "neptune.vat-returns.selected-period";

const isValidDate = (value) => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return false;
  }

  const parsed = dayjs(value);

  return parsed.isValid() && parsed.format("YYYY-MM-DD") === value;
};

export const currentVatQuarter = (date = dayjs()) => {
  const currentDate = dayjs(date);
  const quarterStartMonth = Math.floor(currentDate.month() / 3) * 3;
  const periodStart = currentDate.month(quarterStartMonth).startOf("month");

  return {
    period_start: periodStart.format("YYYY-MM-DD"),
    period_end: periodStart
      .add(3, "month")
      .subtract(1, "day")
      .format("YYYY-MM-DD"),
  };
};

export const readSelectedVatReturnPeriod = (storage) => {
  try {
    const value = JSON.parse(storage?.getItem(VAT_RETURN_PERIOD_STORAGE_KEY));

    if (
      !isValidDate(value?.period_start) ||
      !isValidDate(value?.period_end) ||
      dayjs(value.period_end).isBefore(value.period_start)
    ) {
      return null;
    }

    return {
      period_start: value.period_start,
      period_end: value.period_end,
    };
  } catch {
    return null;
  }
};

export const rememberSelectedVatReturnPeriod = (storage, period) => {
  if (
    !isValidDate(period?.period_start) ||
    !isValidDate(period?.period_end) ||
    dayjs(period.period_end).isBefore(period.period_start)
  ) {
    return;
  }

  try {
    storage?.setItem(
      VAT_RETURN_PERIOD_STORAGE_KEY,
      JSON.stringify({
        period_start: period.period_start,
        period_end: period.period_end,
      }),
    );
  } catch {
    // The workspace still works when storage is unavailable or full.
  }
};
